const checkIsAnotherSender = (array, item, index) => {
  const prevMessage = index > 0 ? array[index - 1] : null;
  const currentSender = item && item.sender && item.sender.sender_id;
  const prevSender = prevMessage ? prevMessage && prevMessage.sender && prevMessage.sender.sender_id : null;

  return currentSender !== prevSender;
}

export default checkIsAnotherSender;